<script lang="ts" setup>
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Navigation, Scrollbar } from 'swiper/modules'

import 'swiper/css'
import 'swiper/css/scrollbar'

// import 'swiper/css/navigation';
// import 'swiper/css/pagination';

import type { IProps } from './GoodHabits.types'
defineProps<IProps>()

const modules = [Navigation, Scrollbar]
const breakpoints = {
  0: {
    slidesPerView: 1,
    spaceBetween: 0,
  },
}

</script>

<template>
  <div
    class="carousel"
  >
    <div class="carousel__swiper">
      <swiper
        ref="sliderRef"
        :scrollbar="{ draggable: true }"
        :breakpoints="breakpoints"
        :modules="modules"
        navigation
      >
        <swiper-slide
          v-for="(item, index) in items"
          :key="index"
        >
          <div class="carousel__list_item">
            <img
              :src="item?.url"
              :alt="item?.alternative"
              class="carousel__list_item-image"
            >
          </div>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.carousel {
  display: flex;
  flex-direction: column;
  width: 31rem;
  height: 31rem;
  margin: -10rem auto 0;
  padding: 0;

  &__swiper {
    max-width: 31rem;
    overflow: hidden;
  }

  .button {
    align-self: center;
  }

  &__list {
    display: flex;
    width: 100%;

    &_item {
      flex: 1;
      width: 100%;

      &-image {
        border-radius: 1.6rem;
      }
    }
  }

  :deep() {
    .swiper {

      svg {
        display: none;
      }

      .swiper-button-prev,
      .swiper-button-next {
        position: absolute;
        top: inherit;
        right: 5%;
        bottom: 5%;
        z-index: 10;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 6rem;
        height: 6rem;
        background-position: center;
        visibility: visible;
        cursor: pointer;
        transition: all 0.3s ease-in-out;

        &.swiper-button-disabled {
          display: none;
        }
      }

      &:hover {

        .swiper-button-prev,
        .swiper-button-next {
          visibility: visible;
        }
      }

      .swiper-button-prev {
        right: 30%;
        left: inherit;
        background-image: url('/icons/icon_slider_arrow.svg');
        transform: rotate(180deg);
      }

      .swiper-button-next {
        right: 5%;
        background-image: url('/icons/icon_slider_arrow.svg');
      }
    }
  }

  @include atXS {
    position: absolute;
    right: 5%;
    bottom: 0;
  }

  @include atM {
    right: 0;
    width: 50rem;
    height: 50rem;
    margin: 0;

    &__swiper {
      max-width: 100%;
      width: 50rem;
    }

    &__list {
      &_item {
        flex: 0;
        width: 100%
      }
    }

    :deep() {
      .swiper {
        .swiper-button-prev {
          right: 20%;
        }

        .swiper-button-next {
          right: 5%;
        }
      }
    }
  }
}
</style>
